import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams, Page, Pageable } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConsultaProjetoVO, Identity, InformacoesProjetoVO, ObjectValue, Projeto } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class ProjetoService {

  private readonly service = '/sepin-backend/rest/projetos';

  constructor(private readonly http: McticHttpClient) {
  }

  consultar(consultaProjetoVo: ConsultaProjetoVO, pageable: Pageable) {
    const queryParams = new McticHttpParams()
      .setNumber('id', consultaProjetoVo.id)
      .set('nome', consultaProjetoVo.nome)
      .set('sigla', consultaProjetoVo.sigla)
      .set('identificacao', consultaProjetoVo.identificacao)
      .set('outraEspecificacaoProjeto', consultaProjetoVo.outraEspecificacaoProjeto)
      .setNumber('codigoTipoProjeto', consultaProjetoVo.codigoTipoProjeto)
      .setMoment('dataInicio', consultaProjetoVo.dataInicio)
      .setMoment('dataFim', consultaProjetoVo.dataFim)
      .setPageable(pageable);

    return this.http.get<Page<Projeto>>(`${this.service}/query`, { params: queryParams.toHttpParams() });
  }

  obterPorId(id: number) {
    return this.http.get<InformacoesProjetoVO>(`${this.service}/${id}`);
  }

  obterTiposTelefone() {
    return [{ id: 1, tipo: 'Fixo' }, { id: 2, tipo: 'Celular' }];
  }

  alterar(informacoesProjeto: InformacoesProjetoVO) {
    return this.http.put(this.service, informacoesProjeto);
  }

  excluir(id: number) {
    return this.http.delete(`${this.service}/${id}`);
  }

  salvar(informacoesProjeto: InformacoesProjetoVO) {
    return this.http.post<Identity<number>>(this.service, informacoesProjeto);
  }

  obterValorTotalDispendios(idProjeto: number) {
    return this.http.get<ObjectValue<number>>(`${this.service}/${idProjeto}/valor-total-dispendios`);
  }

  verificarProjetoPeriodoSuspensao(idInstituicao: number){
    return this.http.get<Observable<any>>(`${this.service}/${idInstituicao}/suspensao`);
  }

  obterProjetoPorNome(nome: string): Observable<Projeto[]> {
    const queryParams = new McticHttpParams().set('nome', nome);
    return this.http.get<Page<Projeto>>(`${this.service}/query`, { params: queryParams.toHttpParams() }).pipe(
      map(o => o.content)
    );
  }

}
